<template>
    <div style="background-color: #F7F7F9;min-height: calc(100vh - 8.5rem)">
        <nav-bar></nav-bar>
        <div class="top-box">
            <div class="out-box">
                <div class="input-box">
                    <i class="iconfont icon-Magnifier" @click="search"></i>
                    <i class="el-icon-circle-close" @click="clearSearch" :class="{'clear-active':keywords}"></i>
                    <input type="text" v-model="keywords" class="input-ipt" @keydown.enter="search" placeholder="请输入关键词">
                    <button class="search-button" @click="search">搜索</button>
            </div>
            </div>
            <img style="height: 35rem;width: 100%;object-fit: cover;" src="../assets/image/collegeCenter/banner.png" alt="">
            <div class="options-box">
                <p style="font-weight: 700;color: #3F3F3F;">地区选择：</p>
                <div class="option-content">
                    <div v-for="(item,index) in areaData" :class="{'active':currentArea==item}" @click="selectArea(item)" :key="index">{{ item }}</div>
                </div>
            </div>
        </div>
        <div class="college-box">
            <div v-for="(item,index) in collegeList" :key="index" @click="goCollege(item)" class="college-item">
                <img :src="$severUrl(item.coverUrl)" alt="">
                <div class="bottom">
                    <p class="college-name overflow">{{ item.schoolName }}</p>
                   <div style="display: flex;justify-content: space-between;margin-top: 1.5rem;">
                    <p>{{ item.area }}</p>
                    <p>{{ `${item.resDataCount}个资源` }}</p>
                   </div>
                </div>
            </div>
        </div>
        <div class="page-box" v-if="pages.total>0">
            <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.current"
            :page-sizes="[8, 16, 24,32]"
            :page-size="pages.size"
            :pager-count="5"
            :layout="$store.state.media.layout"
            :total="pages.total">
            </el-pagination>
        </div>
        <no-data v-if="pages.total==0" style="margin-bottom: 7rem;"></no-data>
        <bottom-slider></bottom-slider>
    </div>
</template>

<script>
import { PageSchoolList } from '@/api/collegeConfig';
import NoData from '../components/common/NoData.vue';
export default {
  components: { NoData },
        data(){
            return {
                keywords:'',
                collegeList:[],
                /**当前选中省份 */
                currentArea:'全部',
                /**省份 */
                areaData:[
                    "全部",
                    "北京市",
                    "天津市",
                    "河北省",
                    "山西省",
                    "内蒙古自治区",
                    "辽宁省",
                    "吉林省",
                    "黑龙江省",
                    "上海市",
                    "江苏省",
                    "浙江省",
                    "安徽省",
                    "福建省",
                    "江西省",
                    "山东省",
                    "河南省",
                    "湖北省",
                    "湖南省",
                    "广东省",
                    "广西壮族自治区",
                    "海南省",
                    "重庆市",
                    "四川省",
                    "贵州省",
                    "云南省",
                    "西藏自治区",
                    "陕西省",
                    "甘肃省",
                    "青海省",
                    "宁夏回族自治区",
                    "新疆维吾尔自治区",
                    "台湾省",
                    "香港特别行政区",
                    "澳门特别行政区"
                ],
                pages:{
                    current:1,
                    size:8,
                    total:0
                }
            }
        },
        methods:{
            setTopHeight(){
                let option=document.querySelector('.options-box');
                if(option){
                    let height=option.clientHeight;
                    let dom=document.querySelector('.college-box');
                    if(dom){
                        dom.style.paddingTop=height-40+'px';
                    }
                }
            },
            goCollege(item){
                window.open(window.location.origin+`?institutionTenantId=${item.tenantId}&collegeName=${item.schoolName}`, '_blank');
            },
            /**清空搜索 */
            clearSearch(){
                this.keywords='';
                this.search();
            },
            handleSizeChange(e){
                this.pages.size=e;
                this.pages.current=1;
                this.pageSchoolList();
            },
            handleCurrentChange(e){
                this.pages.current=e;
                this.pageSchoolList();
            },
            /**选择省份 */
            selectArea(item){
                this.currentArea=item;
                this.search();
            },
            pageSchoolList(){
                let city='';
                if(['内蒙古自治区','黑龙江省'].includes(this.currentArea)){
                    city=this.currentArea.substring(0,3);
                }else{
                    city=this.currentArea.substring(0,2);
                }
                let params={
                "area":city=='全部'?'':city,
                "current": this.pages.current,
                "schoolName": this.keywords,
                "size": this.pages.size
                }
                PageSchoolList(params).then(res=>{
                    if(res.code==200){
                        this.collegeList=res.data.records;
                        this.pages.total=res.data.total;
                    }
                })
            },
            search(){
                this.pages.current=1;
                this.pageSchoolList();
            }
        },
        mounted(){
            this.pageSchoolList();
            this.setTopHeight();
            window.addEventListener('resize',this.setTopHeight);
        },
        destroyed(){
            window.removeEventListener('resize',this.setTopHeight);
        }
    }
</script>

<style lang="less" scoped>
.clear-active{
    opacity: 1 !important;
}
.college-box{
    display: flex;
    padding: 15rem var(--padding) 0 var(--padding);
    flex-wrap: wrap;
    row-gap: 4rem;
    column-gap: 1.7rem;
}
.bottom{
    padding: 2.5rem 2rem;
    background-color: #ffffff;
    color: #9BA0B0;
    font-size: 14px;
}
.college-item{
    width: calc((100% - 5.1rem)/4);
    min-width: 28rem;
    box-shadow: 0px 0px 12px 0px rgba(225,229,239,0.30); 
    cursor: pointer;
    transition: all 0.3s;
    img{
        width: 100%;
        aspect-ratio: var(--aspectRatio);
        object-fit: cover;
    }
}
.college-item:hover{
    transform: translateY(-2rem);
}
.college-name{
    font-size: 2rem;
    font-weight: 700;
    color: #151C34;
}
.college-des{
    margin-top: 1.8rem;
    font-size: 16px;
    color: #9BA0B0;
}
.top-box{
    margin-top: 8rem;
    position: relative;
}
.options-box{
    background: #ffffff;
    border-radius: 10px;
    position: absolute;
    left: var(--padding);
    right:var(--padding) ;
    top: 24rem;
    padding:3.5rem 0rem 1.5rem 3.5rem;
    display: flex;
}
.option-content{
    display: flex;
    flex-wrap: wrap;
    color: #3f3f3f;
    &> :nth-child(n){
        padding-bottom: 5px;
        margin-right: 5rem;
        margin-bottom: 1rem;
        cursor: pointer;
        border-bottom:2px solid transparent;
    }
}
.active{
    border-bottom:2px solid #3972FF !important;
    color: #3972FF;
}
.out-box{
    width: calc(100% - 2*var(--padding));
    display: flex;
    justify-content: center;
    top: 8rem;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
}
.input-box{
    display: inline-flex;
    max-width: 100%;
    position: relative;
    .icon-Magnifier{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 2rem;
        color: #BFC0C8;
        cursor: pointer;
        font-size: 1.8rem;
    }
    .el-icon-circle-close{
        position: absolute;
        right: 11rem;
        top: 50%;
        font-size: 1.8rem;
        transform: translateY(-50%);
        color: #d7dae2;
        cursor: pointer;
        transition: all 0.3s;
        opacity: 0;
        z-index: 99;
    }
    .el-icon-circle-close:hover{
        color: var(--blue);
    }
}
.input-ipt{
    width: 60rem;
    height: 4.5rem;
    background: #ffffff;
    border: 1px solid #d7d9e1;
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
    padding-left: 4.5rem;
    padding-right: 4.5rem;
    flex-shrink: 1;
}
.search-button{
    width: 10rem;
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
    background-color: #3972FF;
    cursor: pointer;
    border: none;
    color: #ffffff;
    font-size: 14px;
    flex-shrink: 0;
}
input:focus {
  outline: none; /* 首先移除默认的轮廓样式 */
  border: 1px solid none; /* 设置焦点时的边框颜色 */
  transition: all 0.3s;
}

input::placeholder {
  font-size: 14px;
}
.page-box{
    padding: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
}
@media screen and (max-width:750px){
    .college-item{
       width: 100% !important;
    }
}
</style>